import { useOrderDetails } from 'hooks/api';
import { useParams } from 'react-router-dom';
import { Typography, Row } from 'antd';

import styles from './index.module.scss';
import { PaymentSystem } from './components/PaymentSystem';
import { OrderInfo } from './components/OrderInfo';
import { UserInfo } from './components/UserInfo';
import { Location } from './components/Location';
import { DeliveryInfo } from './components/DeliveryInfo';

const { Title } = Typography;

const Details = () => {
  const { id } = useParams();
  const { data: order } = useOrderDetails({ id });

  return (
    <div>
      <Title level={2}>Order details</Title>
      {
        order ? (
          <Row className={styles.container}>
            <UserInfo order={order} className={styles.card} />
            <OrderInfo order={order} className={styles.card} />
            <PaymentSystem order={order} className={styles.card} />
            <Location location={order.location} className={styles.card} />
          </Row>
        ) : null
      }
    </div>
  );
};

export default Details;
